'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navi = void 0;
var $ = require("jquery");
var Navi = /** @class */ (function () {
    function Navi() {
        $('.trigSpNavi').on('click', function (e) {
            var isShow = $(e.currentTarget).attr('data-is-show');
            if (isShow === 'false') {
                $(e.currentTarget).attr('data-is-show', 'true');
                $('html, body').css('overflow', 'hidden');
                $('.bulletSpNavi').fadeIn('slow');
            }
            else {
                $(e.currentTarget).attr('data-is-show', 'false');
                $('html, body').css('overflow', 'auto');
                $('.bulletSpNavi').fadeOut('slow');
            }
        });
    }
    return Navi;
}());
exports.Navi = Navi;
exports.default = Navi;
